import React from "react";
import { useLoading } from "../contexts/LoadingContext";

const LoadingTest = () => {
  const { showLoading, hideLoading } = useLoading();

  // 模擬 API 請求
  const simulateApiCall = async () => {
    showLoading();
    try {
      // 模擬 3 秒的延遲
      await new Promise(resolve => setTimeout(resolve, 3000));
      alert("載入完成！");
    } finally {
      hideLoading();
    }
  };

  // 模擬頁面轉換
  const simulatePageTransition = async () => {
    showLoading();
    try {
      // 模擬 2 秒的延遲
      await new Promise(resolve => setTimeout(resolve, 2000));
      alert("頁面轉換完成！");
    } finally {
      hideLoading();
    }
  };

  // 模擬檔案上傳
  const simulateFileUpload = async () => {
    showLoading();
    try {
      // 模擬 4 秒的延遲
      await new Promise(resolve => setTimeout(resolve, 4000));
      alert("檔案上傳完成！");
    } finally {
      hideLoading();
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex flex-col items-center justify-center space-y-8 p-6">
      <h1 className="text-2xl font-bold text-gray-800 dark:text-white">🚀 Loading 測試頁面</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* API 請求測試 */}
        <button
          onClick={simulateApiCall}
          className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded transition-colors"
        >
          模擬 API 請求
        </button>

        {/* 頁面轉換測試 */}
        <button
          onClick={simulatePageTransition}
          className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded transition-colors"
        >
          模擬頁面轉換
        </button>

        {/* 檔案上傳測試 */}
        <button
          onClick={simulateFileUpload}
          className="bg-purple-500 hover:bg-purple-600 text-white font-bold py-2 px-4 rounded transition-colors"
        >
          模擬檔案上傳
        </button>
      </div>

      <div className="mt-8 text-center text-gray-600 dark:text-gray-400">
        <p>點擊按鈕來測試不同場景的載入效果</p>
        <p className="mt-2">每個按鈕都會觸發不同時間長度的載入動畫</p>
      </div>
    </div>
  );
};

export default LoadingTest;
